import React from 'react';

export default function FooterSection() {
  return (
    <footer className="footer">
      <div className="footer-content">
      </div>
    </footer>
  );
}